
const tabsData = [
    {
      label: "Responsive",
      content:
        "No Code, No Problem: Say goodbye to complex programming languages and tedious lines of code. With BOSS, you can build your dream app using simple drag-and-drop tools. It’s like assembling your favorite LEGO set, but with a dash of retail magic!",
    },
    {
      label: "Mobile",
      content:
        "Tailored for Every Store: Whether you’re a cozy coffee shop, a chic boutique, or a bustling hardware store, BOSS has got your back. Our platform adapts to your unique business needs, ensuring a seamless shopping experience for your customers.",
    },
    {
        label: "Support",
        content:
          "Customer Love, Guaranteed: Engage your shoppers with personalized notifications, loyalty programs, and special offers. They’ll be addicted to your app faster than you can say “discount code.”",
      },
  ];

  export default tabsData;
